<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="0" rounded="xxl" class="app-card">
            <v-card-title>
              <AppPageHeader
                icon="mdi-cash-multiple"
                title="Vendor Payments"
                subtitle="Every payment recorded against a vendor bill"
                style="width: 100%"
              />
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="6">
                  <v-text-field
                    solo
                    rounded
                    v-model="filter.search_keyword"
                    label="Search Reference #, Bill # or Vendor... "
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    @click:clear="
                      (filter.search_keyword = null), (page = 1), getData()
                    "
                    @keydown.enter="(page = 1), getData()"
                  ></v-text-field>
                </v-col>
                <v-col sm="4">
                  <v-autocomplete
                    solo
                    rounded
                    v-model="filter.vendor_id"
                    :items="vendors"
                    item-text="name"
                    item-value="id"
                    label="Vendor"
                    @input="(page = 1), getData()"
                    prepend-inner-icon="mdi-domain"
                    clearable
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col md="12">
          <v-card elevation="0" rounded="xxl" class="app-card">
            <v-card-text>
              <section v-if="isLoading" style="height: 285px">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
              <v-simple-table
                v-else
                fixed-header
                height="500"
                class="striped-table"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Sr No</th>
                      <th class="text-left">Payment Date</th>
                      <th class="text-left">Vendor</th>
                      <th class="text-left">Bill Number</th>
                      <th class="text-left">Mode</th>
                      <th class="text-left">Reference</th>
                      <th class="text-right">Amount</th>
                      <!-- <th class="text-right action_th">Action</th> -->
                    </tr>
                  </thead>
                  <tbody v-if="payments.length != 0">
                    <tr v-for="(payment, i) in payments" :key="`payment_${i}`">
                      <td style="min-width: 85px">{{ i + 1 }}</td>
                      <td>{{ payment.payment_date | niceDate }}</td>
                      <td>{{ payment.vendor ? payment.vendor.name : "" }}</td>
                      <td>
                        <router-link
                          v-if="payment.purchase_bill"
                          :to="`/purchase-bills/${encryptIt(
                            payment.purchase_bill.id,
                          )}`"
                        >
                          {{ payment.purchase_bill.bill_number }}
                        </router-link>
                      </td>
                      <td>{{ paymentModeLabels[payment.payment_mode] }}</td>
                      <td>{{ payment.reference_number || "-" }}</td>
                      <td class="text-right mono-figure">₹{{ payment.amount }}</td>
                      <!-- <td class="text-right">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-bind="attrs"
                              v-on="on"
                              fab
                              x-small
                              class="my-auto"
                              color="error"
                              @click="Delete_this(payment.id)"
                            >
                              <v-icon dark> mdi-delete </v-icon>
                            </v-btn>
                          </template>
                          <span>Delete this payment</span>
                        </v-tooltip>
                      </td> -->
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="8">
                        <AppEmptyState
                          icon="mdi-cash-multiple"
                          title="No vendor payments yet"
                          message="Payments recorded against a purchase bill will show up here."
                        />
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-pagination v-model="page" :length="paginationLength">
              </v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
import AppEmptyState from "@/components/AppEmptyState.vue";
import AppPageHeader from "@/components/AppPageHeader.vue";
export default {
  name: "vendorPaymentsPage",
  components: { AppEmptyState, AppPageHeader },
  data() {
    return {
      filter: {
        vendor_id: "",
      },
      page: 1,
      paginationLength: 0,
      count: 0,
      payments: [],
      vendors: [],
      paymentModeLabels: {
        0: "Cash",
        1: "Bank Transfer",
        2: "Cheque",
        3: "UPI",
        4: "Other",
      },
      isLoading: false,
    };
  },
  watch: {
    page: "getData",
  },
  mounted() {
    this.getData();
    this.getMasters();
  },
  methods: {
    async getMasters() {
      await axios
        .get(`masters?context=purchase_bill`)
        .then((response) => {
          this.vendors = response.data.vendors || [];
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    async getData() {
      this.isLoading = true;
      this.filter.vendor_id = this.filter.vendor_id
        ? this.filter.vendor_id
        : "";
      let query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        this.rowsPerPage +
        "&vendor_id=" +
        this.filter.vendor_id +
        "&search_keyword=" +
        (this.filter.search_keyword || "");
      await axios
        .get(`vendor_payments?${query}`)
        .then((response) => {
          this.payments = response.data.data;
          this.count = response.data.count;
          this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
        })
        .catch(function (error) {
          console.log(error);
        });
      this.isLoading = false;
    },
    async Delete_this(id) {
      await axios
        .post(`/vendor_payments/delete/${this.encryptIt(id)}`)
        .then(() => {
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>
